// @flow
import React from 'react';
import {CardsSlider, LodgeCard } from '../../../components';
import { decamelizeKeys } from 'humps';
import filter from 'lodash/filter';

import featuredLodgesData from './featuredLodges.json';

type Props = {
  placeId: string,
  placeName: string,
  lodges: Array<Object>,
};

const placesWithFeaturedLodges = Object.keys(featuredLodgesData);
const hasFeaturedLodges = placeId => placesWithFeaturedLodges.includes(placeId);


export default function FeaturedLodges({ placeId, placeName, lodges }: Props) {
  const showLodges = hasFeaturedLodges(placeId);
  if (!showLodges) return null;
  const featuredLodges = filter(lodges, ({ id }) => featuredLodgesData[placeId].includes(id));
  if (featuredLodges.length === 0) return null;
  return (
    <CardsSlider
      title={placeName ?  `Featured Lodges In ${placeName}` : ''}
      endpoint={`featuredLodgesIn${placeId}`}
      Card={LodgeCard}
      showNoOfCards={3}
      data={decamelizeKeys(featuredLodges)}
    />
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Listings/FeaturedLodges.js